import Vue from "vue";
import PreviredWidgetTester from "./App.vue";
import { name as widgetName } from '../package.json';

Vue.config.ignoredElements = [ widgetName ];

new Vue({
  render: h => h(PreviredWidgetTester)
}).$mount("#app");
